import { a11yClick } from './util';

(function(Drupal, $, once) {
  'use strict';

  Drupal.behaviors.sideNav = {
    attach: function(context, settings) {
      
        $(once('side-nav', '.region-sidebar-left .menu--main > .menu', context)).each(function() {
        let $sideMenu = jQuery(this);
        let $thisTopMenuItem = $sideMenu.find('.menu-depth--0.menu-item--active-trail');
        let $thisTopMenuLink = $thisTopMenuItem.find('> a');
        let $menuItemsWithDropdown = $thisTopMenuItem.find('.menu-item--has-dropdown');


        $thisTopMenuLink.on('click keyup', function(event) {
          event.preventDefault();
          event.stopPropagation();

          if (a11yClick(event) === true) {
            if (jQuery(window).width() >= 1200) {
              window.location = $thisTopMenuLink.attr('href');
            }
            else {
              $thisTopMenuItem.toggleClass('mobile-open');
            }
          }
        });


        $menuItemsWithDropdown.each(function() {
          let $thisMenuItem = jQuery(this);
          let $thisDropdownMenu = $thisMenuItem.find('> .dropdown-menu');
          let $thismenuToggle = $thisMenuItem.find('> .submenu-toggle');

          $thismenuToggle.on('click keyup', function(event) {
            event.preventDefault();
            event.stopPropagation();

            if (a11yClick(event) === true) {
              if ($thisMenuItem.hasClass('open')) {
                $thisDropdownMenu.slideUp(200);
                $thisMenuItem.removeClass('open');
              }
              else {
                $thisDropdownMenu.slideDown(200);
                $thisMenuItem.addClass('open');
              }
            }
          });


          // This helps the jquery slide state when the dropdown
          // is already open on load.
          if ($thisMenuItem.hasClass('open')) {
            $thisDropdownMenu.css('display', 'block');
          }
        });
      });
    }
  };


})(Drupal, jQuery, once);
